// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2K9ds","inputWrap":"styles_inputWrap__3_X1S","input":"styles_input__3DrGp"};